import { gql } from '@apollo/client';

export const FETCH_EMAIL_DOMAINS = gql`
    query EmailDomains($id: ID, $sortColumn: EmailDomainColumnsEnum, $sortDirection: SortDirectionEnum) {
        user {
            emailDomains(id: $id, sortColumn: $sortColumn, sortDirection: $sortDirection) {
                id
                domain
                enabled
                createdAt
            }
        }
    }
`;

export const DELETE_EMAIL_DOMAIN = gql`
    mutation DeleteEmailDomain($deleteEmailDomainInput: DeleteEmailDomainInput!) {
        deleteEmailDomain(input: $deleteEmailDomainInput) {
            emailDomain {
                id
            }
        }
    }
`;

export const UPDATE_EMAIL_DOMAIN = gql`
    mutation UpdateEmailDomain($updateEmailDomainInput: UpdateEmailDomainInput!) {
        updateEmailDomain(input: $updateEmailDomainInput) {
            emailDomain {
                id
                domain
                enabled
                createdAt
            }
            errors {
                path
                message
            }
        }
    }
`;

export const ADD_EMAIL_DOMAIN = gql`
    mutation CreateEmailDomain($createEmailDomainInput: CreateEmailDomainInput!) {
        createEmailDomain(input: $createEmailDomainInput) {
            emailDomain {
                id
                domain
                enabled
                createdAt
            }
            errors {
                path
                message
            }
        }
    }
`;
